enum CountryDetectorFactors {
    FACTOR_BY_INSTANCE = 1,
    FACTOR_BY_NETWORK_COOKIE,
    FACTOR_BY_QUERY_STRING,
    FACTOR_BY_BROWSER_LANGUAGE,
    FACTOR_BY_BROWSER_LANGUAGE_AND_TIMEZONE = 41,
    FACTOR_BY_GEOIP = 6,
    FACTOR_BY_FALLBACK,
    FACTOR_BY_FRIEND_INVITE_CODE,
    FACTOR_BY_DEFAULT_INSTANCE
}

export { CountryDetectorFactors };
